import {
  type DataBindingConnectionConfig,
  type PropertyToFieldConnectionConfig,
} from '../types'

export const setConnectionConfigPropertyField = <
  Config extends Extract<
    DataBindingConnectionConfig,
    {
      properties: { [PropertyName in string]: PropertyToFieldConnectionConfig }
    }
  >,
>({
  config,
  propertyName,
  fieldKey,
}: {
  config: Config
  propertyName: keyof Config['properties']
  fieldKey: string
}): Config => {
  const properties: Config['properties'] = config.properties
  return {
    ...config,
    properties: {
      ...properties,
      [propertyName]: {
        ...properties[propertyName],
        ...({ fieldName: fieldKey } satisfies PropertyToFieldConnectionConfig),
      },
    },
  }
}
